import type { LocationQuery } from 'vue-router'
import { format, isBefore, isValid, startOfToday } from 'date-fns'
import { pick, omit } from 'lodash-es'

import { FilterTypeEnum, type BaseQueryStringFilterState, type QueryStringFilterState } from '@/types/filters'

import { QueryStringKeys } from '@/constants/commons'
import { safeJsonParse } from '@myfunnow/web-core'

export interface GetFilterQueryStringReturnType extends BaseQueryStringFilterState {
  restFilter: Record<string, unknown>
}

export function getFilterQueryString(query: LocationQuery): GetFilterQueryStringReturnType {
  const filterState = query[QueryStringKeys.SEARCH_FILTER]
    ? (safeJsonParse(query[QueryStringKeys.SEARCH_FILTER] as string) as QueryStringFilterState)
    : null

  if (!filterState) {
    return {} as GetFilterQueryStringReturnType
  }

  const needToPickKeys = [
    FilterTypeEnum.SORTBY,
    FilterTypeEnum.FILTER_TIME,
    FilterTypeEnum.FILTER_TIMES,
    FilterTypeEnum.LIMIT,
    FilterTypeEnum.DISCOUNT,
    FilterTypeEnum.RATING,
    FilterTypeEnum.MIN_PRICE,
    FilterTypeEnum.MAX_PRICE,
    FilterTypeEnum.START_TIME,
    FilterTypeEnum.END_TIME,
  ]
  const picked = pick(filterState, needToPickKeys)
  const restFilter = omit(filterState, needToPickKeys)

  const toDate = picked[FilterTypeEnum.START_TIME] ? new Date(picked[FilterTypeEnum.START_TIME]) : undefined
  const date = toDate && isValid(toDate) && !isBefore(toDate, startOfToday()) ? format(toDate, 'yyyy-MM-dd') : undefined

  return {
    ...picked,
    restFilter,
    [FilterTypeEnum.START_TIME]: date,
    [FilterTypeEnum.END_TIME]: date,
  }
}
